import { defineMessages } from 'react-intl';

const messages = defineMessages({
  preferred_bp: {
    defaultMessage: 'Preferred IBM Business Partner',
    id: '9Auwhe',
  },
  page_title: {
    id: 'zdoyJ8',
    defaultMessage: 'Cognos Analytics',
  },
  title: {
    id: 'ntpKxl',
    defaultMessage: 'Cognos Demo',
  },
  landing_title: {
    id: '3IZL8a',
    defaultMessage: 'IBM Cognos Analytics',
  },
  landing_subtitle: {
    id: '5wX411',
    defaultMessage: 'Welcome to the Cognos Analytics interactive demo',
  },
  landing_text: {
    id: 'Ujy4mL',
    defaultMessage:
      'Cognos Analytics can help you get AI-powered insights with just a few clicks. Learn how you can unlock the power of self-service analytics.',
  },
  landing_choose_title: {
    id: '+Q3dd+',
    defaultMessage: ' ',
  },
  landing_title1: {
    id: 'JcDZLO',
    defaultMessage:
      'Enabling AI-powered business intelligence across the enterprise',
  },
  tile1_button: {
    id: 'SOdeBi',
    defaultMessage: 'Start demo',
  },
  bookDemo: {
    id: 'u5AfPm',
    defaultMessage: 'Buy now',
  },
  trail: {
    id: 'bNn8vf',
    defaultMessage: 'Try it free',
  },
  home_button: {
    id: 'ejEGdx',
    defaultMessage: 'Home',
  },
});

export default messages;
